import { LookupRouteService } from 'common/data';
import { BaseService } from 'core/services';

class LookupService extends BaseService {
	constructor(apiClient, lookupRouteService) {
		super(apiClient, new LookupRouteService(lookupRouteService));
	}

	createBatch(resource) {
		var url = this.routeService.createBatch();
		return this.apiClient.post(url, resource);
	}
}

export default LookupService;



// WEBPACK FOOTER //
// ./src/common/data/services/LookupService.js